// First-party outbound buy links.
//
// Affiliate URLs pointed straight at ebay.com / partner.tcgplayer.com are a
// well-known target for blocking extensions: the click is either stripped of its
// tracking parameters or cancelled outright, and Pal Stars loses the commission
// and the click record. Routing the click through our own origin
// (`/go/<source>/<kind>/<key>`) keeps the visible href first-party; the server
// logs the click and issues the redirect to the affiliate-tagged merchant URL.
//
// The path carries no personal data, is `Disallow`ed in robots.txt and answers
// with `X-Robots-Tag: noindex`, so it never enters the index.

export type OutboundKind = "card" | "sealed" | "merch";

/** First-party redirect path for a merchant link. */
export function goUrl(sourceId: string, kind: OutboundKind, key: string): string {
  return `/go/${encodeURIComponent(sourceId)}/${kind}/${encodeURIComponent(key)}`;
}
